import { takeLatest } from 'redux-saga/effects';

import {
  CREATE_SPECIALIZATIONS_SUCCESS,
  DELETE_SPECIALIZATION_SUCCESS,
  UPDATE_SPECIALIZATION_SUCCESS,
} from '../../../actions/specializations';

import { onGetSpecializations } from './onGetSpecializations';

export default function* fn() {
  yield takeLatest(CREATE_SPECIALIZATIONS_SUCCESS, onGetSpecializations);

  yield takeLatest(UPDATE_SPECIALIZATION_SUCCESS, onGetSpecializations);

  yield takeLatest(DELETE_SPECIALIZATION_SUCCESS, onGetSpecializations);
}
